import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { ca } from '@cian/analytics';
import { useIsEditor } from 'shared/utils/editorProvider/editorProvider';

type TUIKitButtonProps = {
  action: string;
  category: string;
  label: string;
  size: 'L' | 'M' | 'XS';
};

export const UIKitButton: React.FC<React.PropsWithChildren<TUIKitButtonProps>> = ({
  action,
  category,
  label,
  ...props
}) => {
  const isEditor = useIsEditor();

  const onClick = React.useCallback(() => {
    if (isEditor) {
      return;
    }

    if (category && action && label) {
      ca('eventSite', {
        category,
        action,
        label,
      });
    }
  }, [action, category, isEditor, label]);

  //@ts-expect-error на самом деле children есть всегда
  return <Button {...props} onClick={onClick} />;
};
